import { render, staticRenderFns } from "./BuyingStationRolePermissions.vue?vue&type=template&id=03eb78ee&scoped=true"
import script from "./BuyingStationRolePermissions.vue?vue&type=script&lang=js"
export * from "./BuyingStationRolePermissions.vue?vue&type=script&lang=js"
import style0 from "./BuyingStationRolePermissions.vue?vue&type=style&index=0&id=03eb78ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eb78ee",
  null
  
)

export default component.exports